// extracted by mini-css-extract-plugin
export var truncate = "_k-0";